import toast from 'react-hot-toast';

// Utilitaire de notification personnalisé avec styles avancés et modèles UX
export const customToast = {
  // Messages de succès avec style cohérent
  success: (message, options = {}) => {
    return toast.success(message, {
      duration: 1000,
      style: {
        background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
        color: '#fff',
        borderRadius: '12px',
        padding: '16px 20px',
        fontSize: '14px',
        fontWeight: '500',
        boxShadow: '0 10px 25px rgba(16, 185, 129, 0.3), 0 4px 10px rgba(16, 185, 129, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        backdropFilter: 'blur(10px)',
        maxWidth: '400px',
        minWidth: '300px',
      },
      iconTheme: {
        primary: '#fff',
        secondary: '#10b981',
      },
      ...options,
    });
  },

  // Messages d'erreur avec style amélioré
  error: (message, options = {}) => {
    return toast.error(message, {
      duration: 5000,
      style: {
        background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
        color: '#fff',
        borderRadius: '12px',
        padding: '16px 20px',
        fontSize: '14px',
        fontWeight: '500',
        boxShadow: '0 10px 25px rgba(239, 68, 68, 0.3), 0 4px 10px rgba(239, 68, 68, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        backdropFilter: 'blur(10px)',
        maxWidth: '400px',
        minWidth: '300px',
      },
      iconTheme: {
        primary: '#fff',
        secondary: '#ef4444',
      },
      ...options,
    });
  },

  // Messages de chargement avec style amélioré
  loading: (message, options = {}) => {
    return toast.loading(message, {
      duration: Infinity,
      style: {
        background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
        color: '#fff',
        borderRadius: '12px',
        padding: '16px 20px',
        fontSize: '14px',
        fontWeight: '500',
        boxShadow: '0 10px 25px rgba(59, 130, 246, 0.3), 0 4px 10px rgba(59, 130, 246, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        backdropFilter: 'blur(10px)',
        maxWidth: '400px',
        minWidth: '300px',
      },
      iconTheme: {
        primary: '#fff',
        secondary: '#3b82f6',
      },
      ...options,
    });
  },

  // Messages d'information avec style amélioré
  info: (message, options = {}) => {
    return toast(message, {
      duration: 1000,
      style: {
        background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
        color: '#fff',
        borderRadius: '12px',
        padding: '16px 20px',
        fontSize: '14px',
        fontWeight: '500',
        boxShadow: '0 10px 25px rgba(6, 182, 212, 0.3), 0 4px 10px rgba(6, 182, 212, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        backdropFilter: 'blur(10px)',
        maxWidth: '400px',
        minWidth: '300px',
      },
      iconTheme: {
        primary: '#fff',
        secondary: '#06b6d4',
      },
      ...options,
    });
  },

  // Messages d'avertissement avec style amélioré
  warning: (message, options = {}) => {
    return toast(message, {
      duration: 4000,
      style: {
        background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
        color: '#fff',
        borderRadius: '12px',
        padding: '16px 20px',
        fontSize: '14px',
        fontWeight: '500',
        boxShadow: '0 10px 25px rgba(245, 158, 11, 0.3), 0 4px 10px rgba(245, 158, 11, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        backdropFilter: 'blur(10px)',
        maxWidth: '400px',
        minWidth: '300px',
      },
      iconTheme: {
        primary: '#fff',
        secondary: '#f59e0b',
      },
      ...options,
    });
  },

  // Notification basée sur les promesses pour opérations asynchrones
  promise: (promise, messages, options = {}) => {
    return toast.promise(promise, {
      loading: messages.loading || 'Chargement...',
      success: messages.success || 'Succès !',
      error: messages.error || 'Quelque chose s\'est mal passé !',
    }, {
      style: {
        borderRadius: '12px',
        padding: '16px 20px',
        fontSize: '14px',
        fontWeight: '500',
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2), 0 4px 10px rgba(0, 0, 0, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(10px)',
        maxWidth: '400px',
        minWidth: '300px',
      },
      ...options,
    });
  },

  // Fermer toutes les notifications
  dismiss: () => {
    toast.dismiss();
  },

  // Fermer une notification spécifique
  dismissSpecific: (toastId) => {
    toast.dismiss(toastId);
  },
};

// Messages de notification prédéfinis pour actions courantes
export const toastMessages = {
  // Authentification
  loginSuccess: '🎉 Bon retour ! Connexion réussie.',
  loginError: '❌ Échec de la connexion. Veuillez vérifier vos identifiants et réessayer.',
  registerSuccess: '🎉 Inscription réussie ! Bienvenue sur Mytableflow !',
  registerError: '❌ Échec de l\'inscription. Veuillez réessayer.',
  logoutSuccess: '👋 Déconnexion réussie !',

  // Opérations CRUD
  createSuccess: (item) => `🎉 ${item} créé avec succès !`,
  createError: (item) => `❌ Échec de la création de ${item}. Veuillez réessayer.`,
  updateSuccess: (item) => `✅ ${item} mis à jour avec succès !`,
  updateError: (item) => `❌ Échec de la mise à jour de ${item}. Veuillez réessayer.`,
  deleteSuccess: (item) => `🗑️ ${item} supprimé avec succès !`,
  deleteError: (item) => `❌ Échec de la suppression de ${item}. Veuillez réessayer.`,

  // Gestion du menu
  categoryCreated: '🎉 Catégorie créée avec succès !',
  categoryUpdated: '✅ Catégorie mise à jour avec succès !',
  categoryDeleted: '🗑️ Catégorie supprimée avec succès !',
  dishCreated: '🎉 Plat créé avec succès !',
  dishUpdated: '✅ Plat mis à jour avec succès !',
  dishDeleted: '🗑️ Plat supprimé avec succès !',
  imageUploadError: '❌ Échec du téléchargement de l\'image. Veuillez réessayer.',
  imageSizeError: '❌ La taille de l\'image doit être inférieure à 5 Mo.',
  imageFormatError: '❌ Veuillez sélectionner un fichier image valide (JPEG, PNG, WebP, GIF).',

  // Gestion des commandes
  orderPlaced: '🎉 Commande passée avec succès ! Votre nourriture sera bientôt préparée.',
  orderUpdated: '✅ Statut de la commande mis à jour avec succès !',
  orderCancelled: '❌ Commande annulée avec succès !',
  cancelError: (item) => `❌ Échec de l\'annulation de ${item}. Veuillez réessayer.`,
  paymentUpdated: '💰 Statut du paiement mis à jour avec succès !',
  orderLoadError: '❌ Échec du chargement des commandes. Veuillez actualiser la page.',

  // Gestion des tables
  tableCreated: '🎉 Table créée avec succès !',
  tableUpdated: '✅ Table mise à jour avec succès !',
  tableDeleted: '🗑️ Table supprimée avec succès !',
  qrGenerated: '📱 Code QR généré avec succès !',
  qrDownloaded: '📥 Code QR téléchargé !',
  urlCopied: '🔗 URL de la table copiée dans le presse-papiers !',
  qrError: '❌ Échec de la génération du code QR.',

  // Gestion du personnel
  staffCreated: '🎉 Membre du personnel créé avec succès !',
  staffUpdated: '✅ Membre du personnel mis à jour avec succès !',
  staffDeleted: '🗑️ Membre du personnel supprimé avec succès !',

  // Opérations du panier
  itemAdded: (item) => `➕ ${item} ajouté au panier`,
  itemRemoved: '🗑️ Article retiré du panier',
  cartEmpty: '🛒 Votre panier est vide. Ajoutez des articles pour continuer.',

  // Profil
  profileUpdated: '🎉 Profil mis à jour avec succès !',
  profileError: '❌ Échec de la mise à jour du profil. Veuillez réessayer.',

  // Validation
  passwordMismatch: '❌ Les mots de passe ne correspondent pas.',
  passwordTooShort: '❌ Le mot de passe doit comporter au moins 6 caractères.',
  requiredField: (field) => `❌ ${field} est requis.`,
  invalidEmail: '❌ Veuillez saisir une adresse e-mail valide.',
  invalidPhone: '❌ Veuillez saisir un numéro de téléphone valide.',
  invalidFormat: (field) => `❌ Veuillez saisir un format ${field} valide.`,

  // Réseau
  networkError: '🌐 Erreur réseau. Veuillez vérifier votre connexion.',
  serverError: '🔧 Erreur serveur. Veuillez réessayer plus tard.',
  timeoutError: '⏰ Délai d\'attente dépassé. Veuillez réessayer.',
  connectionLost: '📡 Connexion perdue. Veuillez vérifier votre internet.',
  serverMaintenance: '🔧 Le serveur est en maintenance. Veuillez réessayer plus tard.',

  // États de chargement
  loading: '⏳ Chargement...',
  saving: '💾 Enregistrement...',
  processing: '⚙️ Traitement...',
  uploading: '📤 Téléchargement...',
  downloading: '📥 Téléchargement...',
  connecting: '🔗 Connexion...',
  authenticating: '🔐 Authentification...',
  creating: '✨ Création...',
  updating: '🔄 Mise à jour...',
  deleting: '🗑️ Suppression...',
  sending: '📨 Envoi...',
  generating: '🎲 Génération...',
  copying: '📋 Copie...',
  exporting: '📊 Exportation...',
  importing: '📥 Importation...',

  // États de succès
  saved: '✅ Enregistrement réussi !',
  copied: '📋 Copié dans le presse-papiers !',
  exported: '📊 Exportation terminée !',
  imported: '📥 Importation terminée !',
  connected: '🔗 Connexion réussie !',
  disconnected: '🔌 Déconnexion réussie !',
  synchronized: '🔄 Synchronisation réussie !',
  backedUp: '💾 Sauvegarde terminée !',
  restored: '🔄 Restauration terminée !',
};

// Fonction utilitaire pour afficher une notification de chargement et retourner la fonction de fermeture
export const showLoadingToast = (message) => {
  const toastId = customToast.loading(message);
  return () => customToast.dismissSpecific(toastId);
};

// Fonction utilitaire pour les opérations asynchrones avec états de chargement
export const withLoadingToast = async (asyncFn, loadingMessage, successMessage, errorMessage) => {
  const dismissLoading = showLoadingToast(loadingMessage);

  try {
    const result = await asyncFn();
    dismissLoading();
    customToast.success(successMessage);
    return result;
  } catch (error) {
    dismissLoading();
    customToast.error(errorMessage || error.message || 'Quelque chose s\'est mal passé !');
    throw error;
  }
};

export default customToast;